import _ from 'lodash';
import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapStateToProps} from '../../../helpers/reselectHelpers';
import {getCompanyUrl} from '../../../store/data/company/companySelectors';
import {getRoles} from '../../../store/data/dataSelectors';
import {
  getFlatActiveOrPendingTeammates,
  getFlatActivePendingOrBlockedTeammates,
  getUser,
} from '../../../store/data/teammates/teammatesSelectors';
import {getFlatTeams} from '../../../store/data/teams/teamsSelectors';
import {InviteTeammatePopoverForm} from './inviteTeammatePopoverForm';

/*
 * Selectors.
 */

/**
 * This should only be shown if there is a single team. We just get the first
 * available team.
 */
const getSingleTeam = createSelector([getFlatTeams], (teams) => {
  if (teams.length < 1) {
    throw new Error('Should be at least one team');
  }

  return teams[0];
});

const getFlatRoles = createSelector(getRoles, (roles) => _(roles).values().compact().value());

/**
 * Only active, pending, or blocked teammates with access to the single team can
 * be cloned.
 */
const getCloneableTeammates = createSelector(
  [getSingleTeam, getFlatActivePendingOrBlockedTeammates],
  (team, teammates) => teammates.filter((t) => Boolean(t.access[team.namespace])),
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  companyUrl: getCompanyUrl,
  cloneableTeammates: getCloneableTeammates,
  existingTeammatesInCompany: getFlatActiveOrPendingTeammates,
  roles: getFlatRoles,
  team: getSingleTeam,
  user: getUser,
}));

export const InviteTeammatePopoverFormContainer = connect(mapStateToProps)(InviteTeammatePopoverForm);
